/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react/button-has-type */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IAlertProps } from '../../interface/IAlertProps';
import { getAbstartcIndex, getDefaultAlertProps } from '../../utils/utils';
import { IApiResult } from '../../interface/IApiResult';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { TextDto } from '../../dto/TextDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import styles from './Dialog.module.css';
import { AtlasNewDto } from '../../dto/AtlasNewDto';
import { apiGetVideoLection } from '../../service/apiGetVideoLection';
import { apiSaveVideoLection } from '../../service/apiSaveVideoLection';

// Импорт Monaco Editor

interface Props {
  open: boolean;
  isEdit?: boolean;
  onClose: () => void;
  dto?: ContentDto;
}

export const DialogVideoConspect: FunctionComponent<Props> = ({
  open,
  dto,
  isEdit,
  onClose,
}) => {
  const [markdown, setMarkdown] = useState<string>('');
  const [markdownEditor, setMarkdownEditor] = useState<string>('');
  const [history, setHistory] = useState<string[]>([]);
  const [historyIndex, setHistoryIndex] = useState<number>(-1);
  const previewRef = useRef<HTMLDivElement>(null);

  const [iframeSrc, setIframeSrc] = useState<string>('about:blank');

  const nameAbstarct = getAbstartcIndex(dto?.abstract ?? '');

  // Реф для Monaco Editor
  const editorRef = useRef<any>(null);

  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);
  const { section } = useParams();

  // Обработка инлайн-разметки
  const processInlineMarkdown = (text: string): string =>
    text
      .replace(
        /\*\*(.*?)\*\*/g,
        `<strong class="${styles.previewStrong}">$1</strong>`
      )
      .replace(/\*(.*?)\*/g, `<em class="${styles.previewEm}">$1</em>`)
      .replace(/`(.*?)`/g, `<code class="${styles.previewCode}">$1</code>`)
      .replace(
        /!\[(.*?)\]\((.*?)\)/g,
        `<img alt="$1" src="$2" class="${styles.previewImage}" />`
      )
      .replace(
        /\[(.*?)\]\((http.*?)\)/g,
        `<a href="$2" target="_blank" class="${styles.previewLink}">$1</a>`
      );

  // Экранирование HTML
  const escapeHtml = (text: string): string => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Замена переносов строк перед ---
  const rereplaceMarkdpwn = (text: string): string => {
    let replacetetxt = text;
    replacetetxt = replacetetxt.replaceAll(
      '\r\n\r\n\r\n\r\n---',
      '\n&nbsp;---'
    );
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n---', '\n&nbsp;---');
    return replacetetxt;
  };

  // Предобработка Markdown для списков
  const preprocessMarkdown = (text: string): string => {
    const lines = text.split('\n');
    let inNumberedList = false;
    let counter = 0;
    let currentLevel = 0;

    const processed = lines.map((line) => {
      const trimmed = line.trim();
      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isEmpty = trimmed === '';
      const isHeading = /^#{1,6}\s/.test(trimmed);

      if (isEmpty || isHeading) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }

      if (numberedMatch) {
        const numberStr = numberedMatch[1];
        const levels = numberStr.split('.').map(Number);
        currentLevel = levels.length;
        counter = levels[levels.length - 1] || 1;
        inNumberedList = true;
        return line;
      } else if (bulletMatch && inNumberedList) {
        return line;
      } else if (bulletMatch) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      } else {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }
    });

    return processed.join('\n');
  };

  // Рендеринг Markdown в HTML
  const renderMarkdown = (text: string): string => {
    if (!text) return '';

    const preprocessedText = preprocessMarkdown(text);
    const processedText = rereplaceMarkdpwn(preprocessedText);
    const lines = processedText.split('\n');
    let inCodeBlock = false;
    let inList = false;
    let listTag = 'ol';
    let listBuffer: string[] = [];
    let currentListLevel = 0;
    let listCounter = 1;

    const processedLines = lines.map((line, index) => {
      if (line.trim().startsWith('```')) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          return `${listContent}`;
        }
        inCodeBlock = !inCodeBlock;
        return line;
      }

      if (inCodeBlock) {
        return `<div class="${styles.previewCodeLine}">${escapeHtml(
          line
        )}</div>`;
      }

      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isListItem = numberedMatch || bulletMatch;
      const isHeading = line.match(/^#{1,6}\s/);
      const isQuote = line.match(/^>\s/);
      const isEmpty = line.trim() === '';

      if (isHeading) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
          const content = line.replace(/^#{1,6}\s/, '');
          return `${listContent}<h${level} class="${
            styles[`previewH${level}`]
          }">${content}</h${level}>`;
        }
        const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
        const content = line.replace(/^#{1,6}\s/, '');
        return `<h${level} class="${
          styles[`previewH${level}`]
        }">${content}</h${level}>`;
      }

      if (isQuote) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const content = line.replace(/^>\s/, '');
          return `${listContent}<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
        }
        const content = line.replace(/^>\s/, '');
        return `<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
      }

      if (isListItem) {
        let content = line;

        const isNumbered = !!numberedMatch;
        const tag = isNumbered ? 'ol' : 'ul';

        let level = 0;
        let displayNumber = '';

        let nomerVstavit = '';

        if (isNumbered && numberedMatch) {
          const numberStr = numberedMatch[1];
          const levels = numberStr.split('.');
          for (let i = 0; i < levels.length; i += 1) {
            nomerVstavit = `${nomerVstavit}${levels[i]}.`;
          }
          level = levels.length - 1;
          displayNumber = levels[levels.length - 1];
          listCounter = parseInt(displayNumber, 10);

          content = content.replace(
            /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/,
            ''
          );
        } else if (bulletMatch) {
          level = 3;
          content = content.replace(/^[-*+]\s/, '');
        }

        content = processInlineMarkdown(content);

        const paddingLeft = 20 + level * 20;
        const showFullNumber = level > 0 && isNumbered ? nomerVstavit : '';
        const listStyle =
          level > 0 && isNumbered
            ? 'list-style: none; padding-left: ' +
              paddingLeft +
              'px; margin-left: 0;'
            : 'padding-left: ' + paddingLeft + 'px; margin-left: 0;';

        if (!inList || listTag !== tag || currentListLevel !== level) {
          if (inList) {
            const prevListContent = listBuffer.join('') + `</${listTag}>`;
            listBuffer = [];
            listTag = tag;
            inList = true;
            currentListLevel = level;

            const startAttr = isNumbered ? ` start="${listCounter}"` : '';
            listBuffer.push(
              `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
            );
            return prevListContent;
          }
          listTag = tag;
          inList = true;
          currentListLevel = level;

          const startAttr = isNumbered ? ` start="${listCounter}"` : '';
          listBuffer.push(
            `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
          );
          return '';
        }

        listBuffer.push(
          `<li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
        );
        return '';
      }

      if (inList) {
        inList = false;
        const listContent = listBuffer.join('') + `</${listTag}>`;
        listBuffer = [];
        currentListLevel = 0;
        listCounter = 1;

        if (isEmpty) {
          return `${listContent}<br>`;
        }

        return `${listContent}<p class="${
          styles.previewParagraph
        }">${processInlineMarkdown(line)}</p>`;
      }

      if (isEmpty) {
        return '<br>';
      }

      return `<p class="${styles.previewParagraph}">${processInlineMarkdown(
        line
      )}</p>`;
    });

    if (inList) {
      const listContent = listBuffer.join('') + `</${listTag}>`;
      processedLines.push(listContent);
    }

    return processedLines
      .join('\n')
      .replace(
        /\[(.*?)\]\(anatatlas:\/\/(.*?)\)/gim,
        `<a href="anatatlas://$2" class="${styles.anatomyLink}" title="Открыть в анатомическом атласе">$1</a>`
      );
  };

  // Обработчик монтирования редактора
  const handleEditorDidMount = (editor: any) => {
    editorRef.current = editor;
    editor.setPosition({ lineNumber: 1, column: 1 });
    editor.focus();
  };

  // Обработчик изменений
  const handleEditorChange = (value: string | undefined) => {
    if (value !== undefined) {
      setMarkdown(value);
    }
  };

  // Отмена изменений
  const undoChange = () => {
    if (historyIndex > 0) {
      const newIndex = historyIndex - 1;
      setHistoryIndex(newIndex);
      setMarkdown(history[newIndex]);
      setMarkdownEditor(history[newIndex]);
    }
  };

  // Вставка текста в редактор
  const insertText = (syntax: string, placeholder: string) => {
    if (!editorRef.current) return;

    const editor = editorRef.current;
    const selection = editor.getSelection();
    const model = editor.getModel();
    if (!model || !selection) return;

    const selectedText = model.getValueInRange(selection) || placeholder;
    const newText = syntax.replace('{text}', selectedText);

    editor.executeEdits('insert', [
      {
        range: selection,
        text: newText,
        forceMoveMarkers: true,
      },
    ]);

    editor.focus();
  };

  // Получение конспекта
  const getVideoLection = async (name: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetVideoLection(name);
    if (apiResult.isSuccess) {
      const content = apiResult.data || '';
      setMarkdown(content);
      setMarkdownEditor(content);
      setHistory([content]);
      setHistoryIndex(0);
      const url = dto?.abstract || 'about:blank';
      setIframeSrc(`${url}?t=${Date.now()}`);
    } else if (apiResult.status !== 404) {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  // Сохранение текста
  const saveText = async (name: string) => {
    const textDto: TextDto = {
      text: markdown,
    };
    setMarkdownEditor(markdown);
    const apiResult: IApiResult = await apiSaveVideoLection(name, textDto);
    if (apiResult.isSuccess) {
      setAlertProps({
        message: 'Данные записаны',
        severity: AlertSeverityEnum.info,
      });
      getVideoLection(name);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const handleClose = () => {
    onClose();
  };

  // Загрузка конспекта при смене типа или открытии
  useEffect(() => {
    if (open) {
      getVideoLection(nameAbstarct);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Сохранение истории
  useEffect(() => {
    if (historyIndex === -1) return;

    const newHistory = history.slice(0, historyIndex + 1);
    if (newHistory[newHistory.length - 1] !== markdown) {
      const updatedHistory = [...newHistory, markdown];
      setHistory(updatedHistory);
      setHistoryIndex(updatedHistory.length - 1);
    }
  }, [markdown]);

  // Настройки Monaco Editor
  const editorOptions = {
    minimap: { enabled: false },
    fontSize: 14,
    lineHeight: 1.8,
    wordWrap: 'on' as const,
    automaticLayout: true,
    scrollBeyondLastLine: false,
    renderWhitespace: 'selection' as const,
    tabSize: 2,
    insertSpaces: true,
    fontFamily: 'Cascadia Code, Fira Code, JetBrains Mono, monospace',
    fontLigatures: true,
    suggest: { showWords: false },
    colorDecorators: true,
    padding: { top: 16, bottom: 16 },
  };

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: {
            backgroundColor: '#e7ebee',
            maxWidth: '100%',
            height: '100%',
          },
        }}
      >
        <BackDropDiv open={backDrop} />
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`Видео конспект - ${dto?.key} ${dto?.title}`}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton title="Закрыть" size="small" onClick={handleClose}>
                <CloseIcon fontSize="large" sx={{ color: '#000000' }} />
              </IconButton>
            </Stack>
          </Stack>
          <header className={styles.editorHeader}>
            <div className={styles.toolbar}>
              <button
                className={styles.toolbarButton}
                onClick={undoChange}
                title="Отменить"
                disabled={historyIndex <= 0}
              >
                ↩️
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => saveText(nameAbstarct)}
                title="Сохранить"
              >
                💾
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('# {text}', 'Заголовок')}
                title="Заголовок H1"
              >
                H1
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('## {text}', 'Подзаголовок')}
                title="Подзаголовок H2"
              >
                H2
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('**{text}**', 'Жирный текст')}
                title="Жирный текст"
              >
                <strong>B</strong>
              </button>
              <button
                className={styles.toolbarButton}
                onClick={() => insertText('*{text}*', 'Курсив')}
                title="Курсив"
              >
                <em>I</em>
              </button>
            </div>
          </header>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              height: '100%',
              overflow: 'auto',
            }}
            className={styles.markdownEditor}
          >
            <div className={styles.editorContainer}>
              <div className={styles.editorContent}>
                {/* Левая панель - редактор */}
                <div
                  className={`${styles.editorPanel} ${styles.splitPanel}`}
                  style={{
                    flex: '1 1 50%',
                    minWidth: '50%',
                    width: '50%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div className={styles.panelHeader}>
                    <h2 className={styles.panelTitle}>Редактор Markdown</h2>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      overflow: 'auto',
                      flex: 1,
                      minHeight: 0,
                    }}
                  >
                    <Editor
                      language="markdown"
                      value={markdownEditor}
                      onChange={handleEditorChange}
                      onMount={handleEditorDidMount}
                      theme="vs-light"
                      height="100%"
                      options={editorOptions}
                    />
                  </div>
                </div>

                {/* Правая панель - preview */}
                <div
                  className={`${styles.previewPanel} ${styles.splitPanel}`}
                  style={{
                    flex: '1 1 50%',
                    minWidth: '50%',
                    width: '50%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div className={styles.panelHeader}>
                    <h2 className={styles.panelTitle}>
                      Предварительный просмотр
                    </h2>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      overflow: 'auto',
                      flex: 1,
                      minHeight: 0,
                      padding: '8px',
                    }}
                  >
                    <iframe
                      src={iframeSrc}
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        borderRadius: '4px',
                      }}
                      title="Preview"
                      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

DialogVideoConspect.defaultProps = {
  isEdit: false,
  dto: undefined,
};
